const orthodontics = {
  hero: {
    titlePrefix: "Moderne",
    titleAccent: "Kieferorthopädie",
    titleSuffix: "Für ein perfektes Lächeln",
    description:
      "Erreichen Sie eine perfekte Ausrichtung und ein schönes Lächeln mit unseren fortschrittlichen kieferorthopädischen Behandlungen. Unser Expertenteam nutzt modernste Technologie, um komfortable, effektive Lösungen für alle Altersgruppen anzubieten.",
    ctas: {
      primary: "Beratungstermin vereinbaren",
      secondary: "Mehr über den Ablauf",
    },
    patientAlt: "Zufriedener Patient",
    patientCount: "1000+ Zufriedene Patienten",
    rating: "Bewertet mit 4.9 von 5",
    imageAlt: "Moderne kieferorthopädische Behandlung",
    tech: {
      calloutTitle: "Moderne Techniken",
      calloutSubtitle: "Sicher & Komfortabel",
    },
  },
  benefits: {
    heading: "WARUM UNSERE KIEFERORTHOPÄDIE WÄHLEN",
    intro:
      "Erleben Sie umfassende kieferorthopädische Behandlungen mit Fokus auf Komfort, Ästhetik und langfristige Ergebnisse.",
    items: [
      {
        title: "Perfekte Ausrichtung",
        description:
          "Erreichen Sie perfekt ausgerichtete Zähne für ein schönes Lächeln und eine verbesserte Bissfunktion.",
      },
      {
        title: "Bessere Mundgesundheit",
        description:
          "Geradere Zähne sind leichter zu reinigen, was das Risiko von Karies und Zahnfleischerkrankungen verringert.",
      },
      {
        title: "Fortschrittliche Technologie",
        description:
          "Profitieren Sie von kürzeren Behandlungszeiten dank unserer modernen kieferorthopädischen Technologien.",
      },
      {
        title: "Individuelle Behandlung",
        description:
          "Personalisierte Behandlungspläne, die auf Ihre spezifischen zahnmedizinischen Bedürfnisse und Ziele zugeschnitten sind.",
      },
    ],
  },
  process: {
    heading: "UNSER KIEFERORTHOPÄDISCHER PROZESS",
    intro:
      "Ein optimierter, komfortabler Weg zu Ihrem perfekten Lächeln mit unserem kieferorthopädischen Expertenteam",
    imageAlt: "Kieferorthopädischer Behandlungsprozess",
    calloutTitle: "Expertenpflege",
    calloutSubtitle: "Erfahrene Spezialisten",
    items: [
      {
        title: "Erstberatung",
        description:
          "Eine gründliche Untersuchung Ihrer Zahnstruktur, um Ihre Bedürfnisse zu beurteilen und Behandlungsoptionen zu besprechen.",
      },
      {
        title: "Individueller Behandlungsplan",
        description:
          "Erstellung eines persönlichen kieferorthopädischen Plans, der auf Ihre spezifischen Ausrichtungsbedürfnisse zugeschnitten ist.",
      },
      {
        title: "Aktive Behandlung",
        description:
          "Regelmäßige Termine zur Anpassung, um sicherzustellen, dass Ihre Behandlung wie geplant verläuft.",
      },
      {
        title: "Retentionsphase (Erhaltungsphase)",
        description:
          "Erhaltung Ihres neuen Lächelns mit maßgefertigten Retainern nach Abschluss der aktiven Behandlung.",
      },
    ],
  },
  faq: {
    heading: "HÄUFIG GESTELLTE FRAGEN",
    intro:
      "Finden Sie Antworten auf häufige Fragen zu unseren kieferorthopädischen Behandlungen",
    items: [
      {
        question: "Wie lange dauert eine kieferorthopädische Behandlung normalerweise?",
        answer:
          "Die Behandlungsdauer variiert je nach individuellen Bedürfnissen, liegt aber typischerweise zwischen 12 und 36 Monaten. Faktoren, die die Behandlungszeit beeinflussen, sind die Schwere der Fehlstellung, das Alter des Patienten und die Mitarbeit bei der Behandlung.",
      },
      {
        question: "Welche Arten von Zahnspangen und kieferorthopädischen Optionen bieten Sie an?",
        answer:
          "Wir bieten ein umfassendes Spektrum an Optionen, einschließlich traditioneller Metallbrackets, keramischer (transparenter) Brackets, selbstligierender Brackets und transparenter Aligner wie Invisalign. Während Ihrer Beratung empfehlen wir die beste Option für Ihren speziellen Fall.",
      },
      {
        question: "Sind kieferorthopädische Behandlungen schmerzhaft?",
        answer:
          "Sie können nach Anpassungen leichte Beschwerden oder Druck verspüren, aber moderne kieferorthopädische Techniken sind darauf ausgelegt, Schmerzen zu minimieren. Jegliche Beschwerden klingen typischerweise innerhalb weniger Tage ab und können mit rezeptfreien Schmerzmitteln behandelt werden.",
      },
      {
        question: "Wie oft muss ich zu Anpassungen kommen?",
        answer:
          "Die meisten Patienten benötigen alle 4-8 Wochen Anpassungen, je nach Behandlungsart und individuellem Fortschritt. Wir erstellen einen Zeitplan, der auf Ihren spezifischen Behandlungsplan zugeschnitten ist.",
      },
      {
        question: "Was passiert, nachdem meine Zahnspange entfernt wurde?",
        answer:
          "Nach der aktiven Behandlung treten Sie in die Retentionsphase ein. Sie erhalten Retainer, um Ihr neues Lächeln zu erhalten. Anfangs tragen Sie diese ganztägig, dann gehen Sie schrittweise dazu über, sie nur nachts zu tragen. Regelmäßige Kontrolluntersuchungen überwachen Ihre Ergebnisse.",
      },
    ],
    bottomLine: "Haben Sie noch Fragen? Wir sind hier, um zu helfen!",
    cta: "Kontaktieren Sie uns",
  },
};

export default orthodontics;

